import { shallowRef, type ShallowRef } from 'vue'

export type TournamentConfigurationSaveFn = () => Promise<void>

export const tournamentConfigurationSaveRef: ShallowRef<TournamentConfigurationSaveFn | null> =
  shallowRef(null)
